import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_NAME } from '../data/atlante';
export function Guarantee() {
  return <section className="bg-ivory px-4 py-5 sm:py-7" data-id="element-78" data-mp="1o33s8bhenif4">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border-2 border-green/60 bg-white p-4 shadow-sm" data-id="element-79" data-mp="223y5b7fee7k4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-green/10 text-green" data-id="element-80" data-mp="1x5d5h9425pw7">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-81" data-mp="19fadet058jxl" />
        </span>
        <div data-id="element-82" data-mp="14gpd6tkw6095">
          <h2 className="text-lg leading-tight text-navy sm:text-xl" data-id="element-83" data-mp="14h8wadma2uor">
            IL TUO ACQUISTO È PROTETTO AL 100%
          </h2>
          <p className="mt-1 text-[13px] font-medium leading-snug text-slate2 sm:text-[15px]" data-id="element-84" data-mp="1j6di04sa7h1m">
            Esplora {PRODUCT_NAME} per 7 giorni. Scopri i sei moduli, le risorse
            visuali, le preparazioni, l’implantoprotesi, i casi clinici, gli
            strumenti di pianificazione e i quattro bonus professionali. Se il
            sistema non fa per te, contattaci entro 7 giorni per ottenere un
            rimborso completo secondo le condizioni di rimborso.
          </p>
        </div>
      </div>
    </section>;
}